<template>
  <v-layout row justify-start align-start class="custom-group" no-gutters :style="layoutStyle">
    <v-flex sm12>
      <v-layout row wrap no-gutters>
        <v-layout xs12 sm2 md2 align-center :no-gutters="noGuttersOnLabel">
          <span class="placeholder" :class="labelClass">{{ label }}</span>
          <AuctionFormInfoTooltip :text="tooltip" />
        </v-layout>
        <v-flex xs12 sm10 md10>
          <v-slider
            style="margin-top: 0"
            class="dutch-slider"
            :value="value"
            :max="max"
            :min="min"
            :step="step"
            always-dirty
            :thumb-size="thumbSize"
            thumb-label="always"
            append-icon="add"
            prepend-icon="remove"
            @click:append="$emit('step-in')"
            @click:prepend="$emit('step-out')"
            @input="$emit('input', $event)"
          >
            <template slot="thumb-label" slot-scope="props">
              <slot name="thumb-label" v-bind="props" />
            </template>
          </v-slider>
        </v-flex>
      </v-layout>
      <slot />
    </v-flex>
  </v-layout>
</template>

<script>
import AuctionFormInfoTooltip from '@/components/forms/auctionForm/AuctionFormInfoTooltip.vue';

export default {
  name: 'AuctionFormLabeledSlider',
  components: { AuctionFormInfoTooltip },
  props: {
    value: { type: Number, required: true },
    label: { type: String, required: true },
    tooltip: { type: String, required: true },
    min: { type: Number, required: true },
    max: { type: Number, required: true },
    step: { type: Number, default: 1 },
    thumbSize: { type: Number, default: 30 },
    layoutStyle: { type: Object, default: () => ({}) },
    labelSmDownMb: { type: Boolean, default: false },
    noGuttersOnLabel: { type: Boolean, default: false },
  },
  computed: {
    labelClass() {
      return this.labelSmDownMb ? { 'mb-5': this.$vuetify.breakpoint.smAndDown } : {};
    },
  },
};
</script>
